import Vue from 'vue';

export default {
  setLoading(state, payload) {
    state.loading = payload;
  },

  setOrganization(state, payload) {
    state.organization = payload;
    state.distributionTypesSet = true;
  },

  // Bandaid fix for Org name not showing for Trainees
  // In Toolbar
  setOrganizationName(state, payload) {
    state.organization.organizationName = payload;
  },

  setCourses(state, payload) {
    state.courses = payload;
    state.coursesLoaded = true;
  },

  setCycles(state, payload) {
    state.cycles = payload;
  },

  setTotalUserCount(state, payload) {
    state.totalUserCount = payload;
  },

  setDistributionTypes(state, payload) {
    state.organization = {
      ...state.organization,
      windowsDistributionType: payload.windowsDistributionType,
      androidDistributionType: payload.androidDistributionType,
      iosDistributionType: payload.iosDistributionType,
      webAppDistributionType: payload.webAppDistributionType,
    };

    state.distributionTypesSet = true;
  },

  setUsageTotal(state, payload) {
    state.usage.totalItems = payload;
  },

  setDailyUsage(state, payload) {
    state.usage.dailyUsage = payload;
  },

  setOfficerUsage(state, payload) {
    state.usage.officerUsage = payload;
  },

  setUsageOfficers(state, payload) {
    state.usage.officers = payload;
  },

  setUserDetailInfo(state, payload) {
    state.userDetail.user = payload;
  },

  setUserDetailAssignedCourses(state, payload) {
    state.userDetail.assignedCourses = payload;
  },

  setUserDetailDailyUsage(state, payload) {
    state.userDetail.userDailyUsage = payload;
  },

  setCourseAssignments(state, payload) {
    state.assign.courseAssignments = payload.resources;
    state.assign.totalItems = payload.totalResources;
    state.assign.totalDistinctCourses = payload.totalDistinctCourses;
    state.assign.totalUnfilteredItems = payload.totalUnfilteredCourses;
    state.assign.hasHybridCourseAssignments =
      payload.hasHybridCourseAssignments;
  },

  setAllSupportRequests(state, payload) {
    state.allSupportRequests = payload;
  },

  setSupportRequests(state, payload) {
    state.supportRequests = payload;
  },

  setAssignedCourseById(state, payload) {
    // Replace the raw DTO wherever it is currently rendered (Course
    // Management list and User Detail assigned courses); never append.
    [state.assign.courseAssignments, state.userDetail.assignedCourses].forEach(
      (collection) => {
        const index = collection.findIndex((x) => x.id === payload.id);
        if (index !== -1) Vue.set(collection, index, payload);
      }
    );
  },

  removeCourseAssignmentById(state, courseAssignmentId) {
    const index = state.assign.courseAssignments.findIndex(
      (assignment) => assignment.id === courseAssignmentId
    );
    if (index === -1) return;

    state.assign.courseAssignments.splice(index, 1);
    state.assign.totalItems = Math.max(0, state.assign.totalItems - 1);
  },

  setUsers(state, payload) {
    state.users = payload;
  },

  setOfficersInOrgDashboard(state, payload) {
    state.officersInOrgDashboard.officerList = payload.resources;
    state.officersInOrgDashboard.totalItems = payload.totalResources;
    state.officersInOrgDashboard.totalUnfilteredItems =
      payload.totalUnfilteredUsers;
  },

  setSsoSync(state, payload) {
    state.ssoSync = payload;
  },

  setTrainingOfficers(state, payload) {
    state.trainingOfficers = payload;
    state.trainingOfficersLoaded = true;
  },

  setCurrentQuizPolicy(state, payload) {
    state.currentQuizPolicy = payload;
  },
};
